import edjsHTML from 'editorjs-html';
import xss from 'xss';

import { cn } from '../index';

export const RichText = ({
  children,
  className,
}: {
  children?: string | null;
  className?: string;
}) => {
  if (!children) return null;

  try {
    const parsed = JSON.parse(children);
    const parser = edjsHTML();
    const content = parser.parse(parsed);
    return (
      <div
        className={cn('prose', className)}
        dangerouslySetInnerHTML={{ __html: xss(content.join('')) }}
      />
    );
  } catch {
    // Fallback for plain text / non-EditorJS descriptions
    return (
      <div className={cn('prose', className)}>
        <p>{children}</p>
      </div>
    );
  }
};